<template>
  <ai-private-events :private-events="privateEvents" :title="title" />
</template>

<script setup lang="ts">
import type { HotelEventFragment } from '~~/domains/graphql';

interface HotelEntertainmentsProps {
  title: string;
  privateEvents?: HotelEventFragment[];
}
defineProps<HotelEntertainmentsProps>();
</script>
